<!--<mat-toolbar color="primary">-->
<!--  <a class="title" href="/">{{ title }}</a>-->

<!--  <div class="toolbar-spacer"></div>-->

<!--  <button mat-button *ngxPermissionsOnly="'OnboardingAdmin'" (click)="redirectToOrganization()">Organization</button>-->
<!--  <button mat-button *ngIf="loginDisplay" [routerLink]="['/settings/user']">Edit Profile</button>-->
<!--  <button mat-raised-button *ngIf="!loginDisplay" (click)="login()">Login</button>-->
<!--  <button mat-raised-button *ngIf="loginDisplay" (click)="logout()">Logout</button>-->

<!--</mat-toolbar>-->
<app-header
  [loginDisplay]="loginDisplay"
  [menu]="menu"
  (changeModule)="changeModule($event)"
  (changeMenu)="changeMenu($event)"
  (logout)="logout()"
></app-header>
<div *ngIf="!isMenuVisible" class="collapsed-menu-strip" (click)="isMenuVisible = true">
    <mat-icon>menu</mat-icon>
</div>
<div class="container">
  <app-vertical-bar
    *ngIf="loginDisplay && menu.length"
    [menu]="menu"
    [isMenuVisible]="isMenuVisible"
    (toggleMenu)="isMenuVisible = $event"
    (moduleSelected)="onModuleSelected($event)"></app-vertical-bar>
  <div class="outlet">
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  <router-outlet *ngIf="!isIframe"></router-outlet>
  </div>
</div>
<app-footer *ngIf="loginDisplay"></app-footer>
<app-phonebook-sidebar></app-phonebook-sidebar>
<app-meeting-notes-panel></app-meeting-notes-panel>
<app-toast></app-toast>
<app-ai-chat-note></app-ai-chat-note>
